import { Card } from '@/components/ui/card';
import { format } from 'date-fns';
import { ClientActions } from './ClientActions';

interface ClientBasicInfoProps {
  client: any;
  mode?: 'view' | 'edit';
}

export const ClientBasicInfo = ({ client, mode = 'view' }: ClientBasicInfoProps) => {
  return (
    <Card className="p-6 bg-[#222222] border-white/10">
      <div className="space-y-6">
        {/* Header with Actions */}
        <div className="flex justify-between items-start">
          <div className="space-y-1">
            <h2 className="text-xl font-semibold text-white">{client.name}</h2>
            <p className="text-sm text-gray-400">{client.email || 'No email provided'}</p>
          </div>
          <ClientActions client={client} />
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-4 p-4 rounded-lg bg-gray-900/50">
          <div>
            <h3 className="text-sm font-medium text-gray-400 mb-1">Phone</h3>
            <p className="text-white">{client.phone || 'Not provided'}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-400 mb-1">Last Contact</h3>
            <p className="text-white">
              {client.last_contact ? format(new Date(client.last_contact), 'PPP') : 'Not available'}
            </p>
          </div>
        </div>

        {/* Client Status Information */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-4 p-4 rounded-lg bg-gray-900/50">
          <div>
            <h3 className="text-sm font-medium text-gray-400 mb-1">Status</h3>
            <p className="text-white">{client.status}</p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-400 mb-1">Source</h3>
            <p className="text-white">{client.source}</p>
          </div>
        </div>

        {/* Notes Section */}
        <div className="p-4 rounded-lg bg-gray-900/50">
          <h3 className="text-sm font-medium text-gray-400 mb-2">Notes</h3>
          <p className="text-white whitespace-pre-wrap">
            {client.notes || 'No notes available'}
          </p>
        </div>
      </div>
    </Card>
  );
};